<template>
  <el-drawer :visible.sync="drawerVisible" :wrapperClosable="false" size="35%">
    <template #title>
      <span>{{ row && row.customerName && row.customerName }}</span>
    </template>
    <div class="wrapper">
      <div
        class="row optional"
        style="display: flex; justify-content: flex-end"
      >
        <el-button
          type="primary"
          plain
          @click="
            () => {
              dialogVisible = true;
            }
          "
        >
          添加
        </el-button>
        <el-button type="primary" plain @click="sortCustomer"
          >更新排序</el-button
        >
      </div>
      <div class="row table">
        <el-table :data="tableData" height="600" border>
          <!-- <el-table-column prop="imgName" label="名称"> </el-table-column> -->
          <el-table-column
            prop="imgUrl"
            label="图片"
            width="200"
            hidden="180"
            align="center"
          >
            <template slot-scope="scope">
              <img :src="scope.row.imgUrl" alt="" class="myimg" />
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" align="center">
            <template slot-scope="scope">
              <el-input-number
                size="small"
                :precision="0"
                v-model="scope.row.sort"
                controls-position="right"
                @change="scope.row.add = '1'"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            fixed="right"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                @click="deleteImg(scope.row.id)"
                type="danger"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float: right"
          layout="total, prev, pager, next"
          :total="total"
          :page-size="10"
          :current-page.sync="currentPage"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="添加图片"
      width="30%"
      :show-close="false"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form :rules="rules" ref="form" :model="form" v-enterToNext="true">
        <el-form-item label="图片" prop="img">
          <el-upload
            :class="{ 'hide-upload': isHideUpload }"
            action=""
            :limit="1"
            accept=".jpg,.png"
            list-type="picture-card"
            :on-preview="onPreview"
            :file-list="form.img"
            :before-remove="removeLicense"
            :http-request="uploadLicense"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              请上传.jpg/.png格式文件，建议尺寸800*800px，文件大小不超过300kb
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序" class="number-footer">
          <el-input-number v-model="form.sort" :precision="0"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              form.img = [];
              isHideUpload = false;
              dialogVisible = false;
            }
          "
          >取 消</el-button
        >
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="
            () => {
              imgEdit('form');
            }
          "
          >确 定</el-button
        >
      </span>
      <el-dialog :visible.sync="imgDialog.show" append-to-body="true">
        <img width="100%" :src="imgDialog.url" alt="" />
      </el-dialog>
    </el-dialog>
  </el-drawer>
</template>

<script>
import { addImage, getImages } from "@/request/api/customer";

export default {
  props: {
    visible: {
      default: false,
      type: Boolean,
      require: true,
    },
    row: {
      default: () => {
        return {};
      },
      type: Object,
      require: true,
    },
  },
  data() {
    let valiIcon = (rule, value, callback) => {
      if (this.form.img.length == 0) {
        callback(new Error("请上传Banner 图"));
      } else {
        callback();
      }
    };
    return {
      submitLoading: false,
      imgDialog: {
        show: false,
        imgUrl: "",
      },
      drawerVisible: false,
      form: {
        img: [],
      },
      dialogVisible: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      isHideUpload: false,
      chooseFactoryId: "",
      total: 0,
      rules: {
        img: [{ required: true, validator: valiIcon }],
      },
    };
  },
  methods: {
    sortCustomer() {
      let arr = [];
      let obj = {};
      this.tableData.forEach((element) => {
        if (element.add == "1") {
          obj.id = element.id;
          obj.sort = element.sort ? element.sort : "";
          arr.push(obj);
          obj = {};
        }
      });
      this.$api.customer.imageSort(arr).then((res) => {
        if (res.error === false) {
          this.getImgPage();
          this.$message.success("更新成功");
        } else {
          this.$message.success(res.msg);
        }
      });
    },
    getImgPage() {
      var sendData = {
        customerId: this.chooseFactoryId,
        pageIndex: 1,
        pageSize: 10,
        keyWord: "",
      };
      this.$api.customer.getImages(sendData).then((res) => {
        if (!res.error) {
          console.log(res);
          this.loading = false;
          this.tableData = res.data.data;
          this.tableData.forEach((item) => {
            if (item.sort == null) {
              item.sort = undefined;
            }
          });

          this.total = res.data.count;
        }
      });
    },

    handleClose(done) {},
    chooseImage(el) {},
    handleCommand() {
      console.log("1111");
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      console.log(1);
    },
    removeLicense() {
      // this.form.img.splice(0, 1);
      this.isHideUpload = false;
      this.form.img = [];
    },
    uploadLicense(fileObj) {
      // const formData = new FormData();
      // formData.append("file", fileObj.file);
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          if (res.code === 0 && res.data[0]) {
            this.isHideUpload = true;
            this.form.img.push({
              customerId: this.chooseFactoryId,
              imgName: fileObj.file.name,
              imgSize: fileObj.file.size,
              imgUrl: res.data[0],
              url: res.data[0],
            });
          }
        })
        .catch((error) => {
          this.submitLoading = false;

          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form.img = [];
          }
        });
    },
    cancel() {
      this.form.img = [];
      this.isHideUpload = false;
    },
    // 添加图片
    imgEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;

        this.form.img[0].sort = this.form.sort;
        this.$api.customer.addImage(this.form.img[0]).then((res) => {
          if (res.error == false) {
            this.getImgPage();
            this.cancel();
            this.dialogVisible = false;
            this.submitLoading = false;
          }
        });
      });
    },
    deleteImg(id) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.customer.imgDelete(id).then((res) => {
            console.log(res);
            if (!res.error) {
              this.getImgPage();
              this.$message.success("删除成功");
            }
          });
        })
        .catch(() => {});
    },
    onPreview(file) {
      // console.log("dfsfd========s", file);
      this.imgDialog.show = true;
      this.imgDialog.url = file.url;
    },
  },
  watch: {
    visible(newVal) {
      this.drawerVisible = newVal;

      const sendData = {
        customerId: this.row.id,
        pageIndex: 1,
        pageSize: 10,
        keyWord: "",
      };
      this.chooseFactoryId = this.row.id;

      if (newVal) {
        this.loading = true;

        this.$api.customer.getImages(sendData).then((res) => {
          if (!res.error) {
            console.log(res);
            this.loading = false;
            this.tableData = res.data.data;
            this.tableData.forEach((item) => {
              if (item.sort == null) {
                item.sort = undefined;
              }
            });

            this.total = res.data.count;
          }
        });
      }
    },
    drawerVisible(newVal) {
      this.$emit("update:visible", newVal);
    },
  },
};
</script>
<style lang="less" scoped>
.big {
  z-index: 9999;
}
.wrapper {
  padding: 10px 20px;
}
button.btn {
  background: #0080ff;
  border: 0px;
  color: #fff;
  padding: 5px 10px;
  margin-right: 10px;
}
button.btn:hover {
  background: #004f9e;
  cursor: pointer;
}
.number-footer {
  width: 100px;
}
.myimg {
  width: 150px;
  height: 150px;
}
.hide-upload {
  .el-upload--picture-card {
    display: none;
  }
  .el-upload__tip {
    margin-top: 0;
  }
}
</style>
